import { util } from 'echarts/core';
import type StandardChart from './StandardChart';
import { getTheme } from './theme';
import { type PresetTheme } from '../theme';
import modelParsers from '../model';
import type { Option } from './option';

/**
 * 配置项管理
 */
export default class Model {
  protected _option: Option;

  protected _theme: PresetTheme;

  constructor(theme?: PresetTheme) {
    this._option = {} as Option;
    this._theme = theme;
  }

  // eslint-disable-next-line class-methods-use-this
  private __preprocess(option: Option) {
    ['xAxis', 'yAxis', 'series'].forEach(optionKey => {
      option[optionKey] = (
        Array.isArray(option[optionKey]) ? option[optionKey] : [option[optionKey]]
      ).filter(Boolean);
    });
  }

  private __parseTheme(option: Option, theme: PresetTheme, chart: StandardChart) {
    if (typeof theme === 'undefined') {
      return this;
    }
    const themeParsers = getTheme(theme);

    themeParsers.forEach(themeParser => {
      themeParser(option, chart);
    });

    return this;
  }

  private __parse(index: number, chart: StandardChart) {
    this.__preprocess(this._option);
    // * 解析主题配置
    this.__parseTheme(this._option, this._theme, chart);
    // * 解析配置
    modelParsers.forEach(modelParser => {
      modelParser.parse(this._option, index, chart);
    });
  }

  /**
   * 预解析配置项
   */
  prepare(chart: StandardChart) {
    this.__parse(0, chart);
  }

  getThemeName() {
    return this._theme;
  }

  getOption() {
    return util.clone(this._option);
  }

  update(option: Option) {
    this._option = util.clone(option);
  }
}
